<template>
  <div>
     <div>
       <a-button type="primary" 
         :disabled="selCompareKeys.length < 2"
         style="margin: 0 0 10px" size="large" @click.stop="handleCompare()">
         对比({{ selCompareKeys.length }})</a-button>
     </div>
     <div>
       <a-table
         :row-selection="{ selectedRowKeys: selCompareKeys, onChange: onSelectChange }"
         :columns="compareColumns"
         :data-source="list"
       >
        <span slot="sex" slot-scope="sex">
          {{ sex === 1 ? '男' : '女'  }}
        </span>
       </a-table>
     </div>
  </div>
</template>
<script>
const columns = [
  {
    key: '1',
    title: '日期',
    dataIndex: 'appDate',
  },
  {
    key: '2',
    title: '姓名',
    dataIndex: 'recordName',
  },
  {
    key: '3',
    title: '性别',
    dataIndex: 'sex',
    scopedSlots: { customRender: 'sex' },
  },
];

export default {
  props: {
    list: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      compareColumns: columns,
      selCompareKeys: [],
      selCompareRows: []
    }
  },
  methods: {
    // 选择对比报告
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selCompareKeys = selectedRowKeys;
      this.selCompareRows = selectedRows
    },

    // 对比
    handleCompare() {
      this.$emit('getReportDetail', this.selCompareRows)
    }
  }
}
</script>
<style lang="less" scoped>

</style>
